export function arrayFromNodeList (nl) {
  var arr = [];
  for (var i = 0, l = nl.length; i < l; i++) {
    arr.push(nl[i]);
  }
  return arr;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/arrayFromNodeList.js
// module id = 88
// module chunks = 0